import { create } from '@bufbuild/protobuf'
import { type ConnectError } from '@connectrpc/connect'
import { useQuery } from '@connectrpc/connect-query'
import { getDemandProcurementMaster } from '@ebalance/proto/bffuser/v1/occto_master_service-OcctoMasterService_connectquery'
import {
  GetDemandProcurementMasterRequestSchema,
  type GetDemandProcurementMasterResponse,
} from '@ebalance/proto/bffuser/v1/occto_master_service_pb'
import type { UseQueryResult } from '@tanstack/react-query'

/**
 * 需要調達計画マスタ full entity 取得 hook。
 * codes / bgs を含む全フィールドを返す。Edit modal の form 初期値に使用する。
 * id が undefined または空文字の場合は query を無効化する。
 */
export function useGetDemandProcurementMaster(
  id: string | undefined,
): UseQueryResult<GetDemandProcurementMasterResponse, ConnectError> {
  return useQuery(
    getDemandProcurementMaster,
    create(GetDemandProcurementMasterRequestSchema, { id: id ?? '' }),
    { enabled: id !== undefined && id !== '' },
  )
}
